/**
 * contains the abi and contract address
*/

export default class PacksContract {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "packHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "previousHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[]",
				"name": "contentHashes",
				"type": "bytes32[]"
			},
			{
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			}
		],
		"name": "newPack",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "packHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			}
		],
		"name": "NewPack",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "packHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			}
		],
		"name": "PackHasContent",
		"type": "event"
	}
        ];           

        this.contractAddress = '0xF7bd2ada59c4ab5AD0f6BFbE94EB4f8eCa18eEDd';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

